<template>
  <div id="storybook-preview-content-type-icons" :class="{ 'show-border': showBorder }">
    <Icon ref="icon" v-show="false" name="..."/>
    <StickyNav has-bg type="under-header" class="m-t-20">
      <div class="section-tool-menu">
        <div class="menu-item">Border: <el-switch v-model="showBorder"/> </div>
        <div class="menu-item">Add Class: <el-input v-model="classAdded" placeholder="Please input" style="max-width: 200px;"/> </div>
      </div>
    </StickyNav>
    <div class="p-l-40 -p-r-40 m-t-40">
      <ul class="unstyle">
        <li v-for="i in contentTypes" :key="i">
          <Icon :name="i" :className="classAdded"/> {{ i }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    Icon: () => import('../../../../../../lib/components/Icon.vue')
  },
  data () {
    return {
      contentTypes: [],
      showBorder: false,
      classAdded: 'font-40'
    }
  },
  mounted () {
    this.$nextTick(() => {
      setTimeout(() => {
        let list = [...Object.values(this.$store.state.contentTypeNameToApp), ...Object.keys(this.$store.state.contentTypeAppToName)]
        list.push(...['scorm', 'learning_playlist', 'category', 'learning_program', 'materials', 'idp', 'menu_exam'])
        list = list.map(icon => icon.replace('-', '_'))
        this.contentTypes = list.map(icon => icon.replace('-', '_'))
      }, 1000)
    })
  }
}
</script>

<style lang="scss">
#storybook-preview-content-type-icons {
  .section-tool-menu {
    display: flex;
    gap: 24px;
    flex-direction: column;
    padding-left: 40px;
  }

  ul {
    column-count: 3;

    li {
      margin-bottom: 10px;

      i {
        margin-right: 5px;
      }
    }
  }

  &.show-border {
    ul {
      li {
        i {
          &.fantasticon, &.fontastic {
            &:before {
              border: solid 1px #ff0000;
            }
          }

          &.material-icons {
            border: solid 1px #ff0000;
          }
        }
      }
    }
  }
}
</style>
